import axios from "axios";
import { baseUrl } from "../utils/config";
import { logout } from "../utils/CommonFunction";

const newBaseUrl = (baseUrlToUse: string | null) => {
  if (!baseUrlToUse) {
    console.error(
      "Base URL is not defined. Please set REACT_APP_BASE_URL in your environment variables.",
    );
    throw new Error("Base URL is not defined");
  }
  if (window.location.protocol === "http:") {
    let newBaseUrl: string | undefined = baseUrlToUse;
    newBaseUrl = newBaseUrl?.replace("https", "http");
    return newBaseUrl;
  } else {
    return baseUrlToUse;
  }
};

export const getRequest = async (endPoint: string) => {
  try {
    const response = await axios({
      url: `${newBaseUrl(baseUrl)}${endPoint}`,
      method: "get",
      headers: {
        "Content-Type": "application/json",
        // Connection: "close",
        Authorization: "Bearer " + global.authToken,
      },
    });
    return response;
  } catch (error: any) {
    console.log("Error in getRequest:", error);
    // if (error.response?.status === 403) {
    // console.log('Error 403: Unauthorized access');
    //   logout("network");
    // }
    throw error;
  }
};

export const postRequest = async (endPoint: string, data: {}) => {
  try {
    const response = await axios({
      url: `${newBaseUrl(baseUrl)}${endPoint}`,
      method: "POST",

      headers: {
        "Content-Type": "application/json",
        // Connection: "close",
        Authorization: "Bearer " + global.authToken,
      },
      data: data,
      // timeout: requestTimeout,
    });
    return response;
  } catch (error: any) {
    // if (error.response?.status === 403) {
    //   logout("network");
    // }
    throw error;
  }
};

export const postRequestMulitiPart = async (endPoint: string, data: {}) => {
  try {
    const response = await axios({
      url: `${newBaseUrl(baseUrl)}${endPoint}`,
      method: "POST",

      headers: {
        "Content-Type": "multipart/form-data",
        // Connection: "close",
        Authorization: "Bearer " + global.authToken,
      },
      data: data,
      // timeout: requestTimeout,
    });
    return response;
  } catch (error: any) {
    // if (error.response?.status === 403) {
    //   logout("network");
    // }
    throw error;
  }
};
